(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("learningItemAddLearningJournal", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: {
                wizard: "="
            },
            templateUrl: "app/learningItems/add/steps/learningItemType/learningItemAddLearningJournalView.html",
            controller: ["notify", "_", "Upload", "$timeout", LearningItemAddLearningJournalCtrl],
            controllerAs: "vm"
        };
        function LearningItemAddLearningJournalCtrl(notify, _, Upload, $timeout) {
            var vm = this;
            vm.$onInit = function () {
                vm.maxFilesAllowed = 1;
                if (!vm.wizard.formData.specificInfo.files)
                    vm.wizard.formData.specificInfo.files = [];
                vm.updateFormValidity();
            };
            //////////////////////////////////////////////////////////////////////
            vm.updateFormValidity = function () {
                vm.wizard.vm.form.$valid = vm.wizard.formData.specificInfo.files.length > 0;
            };
            vm.upload = function (file) {
                if (file) {
                    file.upload = Upload.upload({
                        url: "api/learningitems/temp/files",
                        data: {
                            file: file
                        }
                    });
                    file.upload.then(function (response) {
                        $timeout(function () {
                            vm.wizard.formData.specificInfo.files = vm.wizard.formData.specificInfo.files.concat(response.data);
                            notify({
                                "messageTemplate": "<span translate='common.dropzone.uploadedFileMessage'></span>", "classes": "alert-success"
                            });
                            vm.progress = 0;
                            vm.updateFormValidity();
                        });
                    }, function (response) {
                        if (response.status > 0) {
                            var error = response.data.exceptionMessage ? response.data.exceptionMessage : response.data.message;
                            notify({ "messageTemplate": "<span data-translate>" + error + "</span>", "classes": "alert-danger" });
                        }
                        vm.progress = 0;
                    }, function (evt) {
                        vm.progress = Math.min(100, Math.round(100.0 * evt.loaded / evt.total));
                    });
                }
            };
            vm.reachedMaxFilesUploaded = function () {
                return vm.wizard.formData.specificInfo.files.length >= vm.maxFilesAllowed;
            };
            vm.removeFile = function (fileUrl) {
                vm.wizard.formData.specificInfo.files = _.without(vm.wizard.formData.specificInfo.files, _.find(vm.wizard.formData.specificInfo.files, {
                    fileUrl: fileUrl
                }));
                vm.updateFormValidity();
            };
            vm.validateFile = function (file) {
                if (vm.wizard.formData.specificInfo.files.length >= vm.maxFilesAllowed) {
                    return "maxFiles";
                }
                if (_.includes(_.pluck(vm.wizard.formData.specificInfo.files, "fileName"), file.name)) {
                    return "sameName";
                }
                return true;
            };
        }
    });
}());
